import React from 'react'
import Layout from '../../Components/Layout/Layout'
import '../About/Style.css'
import computer from "../../Assets/computer.svg"
const About = () => {
  return (
    <>
      <Layout>
        <div className='main-about-calendar'>
          <div className='what-cal-ornot'>
            <div className='what-calendar'>
              <p>What the Calendar is</p>
              <ul>
                <li>
                  A tool that provides teams (Events, Marketing & Comms, etc.) with
                  knowledge of upcoming events where JO external efforts are engaged
                  to help prioritize support.
                </li>
                <li>Communication tool for future planning.</li>
                <li>
                  Realtime central source of activities & events to ensure all
                  necessary staff have current information if scheduling changes
                  occur, without having to check multiple calendars.
                </li>
                <li>
                  A record of past events (when in Tableau) that can easily be
                  referenced.
                </li>
                <li>A tool to lessen engagement during PTO to emergency calls.</li>
              </ul>
            </div>
            <div className='what-calendar-not'>
              <p>What the Calendar is NOT</p>
              <ul>
                <li>It is not a “gotcha” or “tracking system”.</li>
                <li>
                  It is not a copy of every event on employee’s calendars. It is
                  limited to external engagements: conferences, BR&Es, meetings
                  w/clients, events (ground breakings, ribbon cuttings, etc.).
                </li>
                <li>It is not a method to invade individuals’ privacy.</li>
                <li>
                  Doctor appointments or other personal matters may be marked
                  private on calendars (however, no personal items will be forwarded
                  regardless).
                </li>
                <li>
                  It is not a tool to create extra work or that will lead to multiple
                  places for parties to find data necessary to be informed and
                  perform their job.
                </li>
                <li>It is not a measurement of production.</li>
              </ul>
            </div>
          </div>
          <div> <img src={computer} alt="" /></div>
        </div>
      </Layout>
    </>
  )
}

export default About
